/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { DesadvUploadResponseV3 } from '../../models/desadv-upload-response-v-3';
import { KeyType } from '../../models/key-type';

export interface PostConsignorDesadv$Params {
  organizationSiteKey: KeyType;
      body: BinaryFileType
}

export function postConsignorDesadv(http: HttpClient, rootUrl: string, params: PostConsignorDesadv$Params, context?: HttpContext): Observable<StrictHttpResponse<DesadvUploadResponseV3>> {
  const rb = new RequestBuilder(rootUrl, postConsignorDesadv.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/edifact');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DesadvUploadResponseV3>;
    })
  );
}

postConsignorDesadv.PATH = '/organization-sites/{organizationSiteKey}/consignor/desadv';
